module.exports = __webpack_public_path__ + "static/media/ic_update_expiry_date.c648408d.svg";